import appEnvironment from '../../simple-flow/app-environment';
import ebUrl from '../../simple-flow/eb-url';
import {
    BASE_PATH,
    VIEW_MODE_MANAGE_DASHBOARD,
} from '../../constants/global-constants';

const { getAppUrl, getApiUrl, getBffUrl } = ebUrl;

const isStandAlone = () => {
    const value = appEnvironment.getVar('standAlone');

    return value;
};

const getEventDataUrl = ({ eventId }) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/eventData.json`,
        );
    }
    return getApiUrl(`/v3/events/${eventId}/`);
};

const getInternalMapUrl = ({ eventId, includeGroups, includeTierColors }) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/map.json`,
        );
    }
    return getBffUrl(
        `/v1/events/${eventId}/spec?includes=data${
            includeTierColors ? ',tier_colors' : ''
        }${includeGroups ? ',groups' : ''}`,
    );
};

const getMapStatusUrl = ({ eventId, promoCode, holdId, viewMode }) => {
    let url;

    if (isStandAlone()) {
        const promoCodeStr = promoCode ? `_${promoCode}` : '';
        const holdIdStr = holdId ? `_${holdId}` : '';

        url = getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/status${promoCodeStr}${holdIdStr}.json`,
        );
    } else {
        const promoCodeStr = promoCode ? `&hold_code=${promoCode}` : '';
        const holdIdStr = holdId ? `&hold_id=${holdId}` : '';

        if (viewMode === VIEW_MODE_MANAGE_DASHBOARD) {
            url = getApiUrl(
                `/v3/events/${eventId}/spec/units/status/?includes=minimum${promoCodeStr}${holdIdStr}`,
            );
        } else {
            url = getBffUrl(
                `/v1/events/${eventId}/units/status?includes=minimum${promoCodeStr}${holdIdStr}`,
            );
        }
    }
    return url;
};

const getTicketSalesUrl = ({
    eventId,
    promoCode,
    pos,
    holdId,
    includeHidden,
}) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/ticket_classes.json`,
        );
    }

    const expansions = ['payment_constraints', 'reserved_seating'];
    const expansionsStr = `&expand=${expansions.join(',')}`;
    const promoCodeStr = promoCode ? `&code=${promoCode}` : '';
    const eventHoldStr = holdId ? `&hold_id=${holdId}` : '';
    const hiddenStr = includeHidden ? '&include_hidden=true' : '';
    const url = getBffUrl(
        `/v1/events/${eventId}/ticket_classes/for_sale?pos=${pos}${expansionsStr}${promoCodeStr}${eventHoldStr}${hiddenStr}`,
    );

    return url;
};

const getAttendeesUrl = ({ cartId }) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${cartId}/attendees.json`,
        );
    }

    const url = getBffUrl(
        `/v1/orders/${cartId}/attendees?expand=ticket_class.reserved_seating,survey,questions`,
    );

    return url;
};

const getCreateOrderUrl = () => {
    if (isStandAlone()) {
        return getAppUrl(`${BASE_PATH}src/mock-data/order.json`);
    }

    const url = getBffUrl(
        '/v1/orders/create?expand=questions,survey,registration_form',
    );

    return url;
};

const getGuestTokenUrl = () => {
    if (isStandAlone()) {
        return getAppUrl(`${BASE_PATH}src/mock-data/guestTokens.json`);
    }
    const url = getApiUrl('/v3/auth/guest_tokens/');

    return url;
};

const getOrderUrl = ({ eventId, cartId }) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/order.json`,
        );
    }
    const url = getBffUrl(`/v1/orders/${cartId}`);

    return url;
};

const getEventInventoryTiersUrl = ({ eventId }) => {
    if (isStandAlone()) {
        return getAppUrl(
            `${BASE_PATH}src/mock-data/events/${eventId}/inventory_tiers.json`,
        );
    }
    const url = getApiUrl(
        `/v3/events/${eventId}/inventory_tiers/?seatmap_number=1`,
    );

    return url;
};

const getSetPaymentInstructionUrl = ({ cartId }) => {
    const url = getApiUrl(
        `/v3/orders/${cartId}/payment_methods/?expand=ticket_class.reserved_seating,survey,questions`,
    );

    return url;
};

const getEventHoldsUrl = ({ eventId }) => {
    const url = getApiUrl(`/v3/events/${eventId}/holds/`);

    return url;
};

const getEventSpecUnitsUrl = ({ eventId }) => {
    const url = getApiUrl(`/v3/events/${eventId}/spec/units/`);

    return url;
};

const getSoldSeatInfoUrl = ({ eventId, seatId }) => {
    const url = getApiUrl(
        `/v3/events/${eventId}/attendees/unit/${seatId}/?expand=promotional_code,reserved_seating`,
    );

    return url;
};

const getUnitsHoldsUrl = ({ eventId }) => {
    const url = getApiUrl(`/v3/events/${eventId}/units/holds/`);

    return url;
};

export default {
    getAttendeesUrl,
    getCreateOrderUrl,
    getEventDataUrl,
    getEventHoldsUrl,
    getEventInventoryTiersUrl,
    getEventSpecUnitsUrl,
    getGuestTokenUrl,
    getInternalMapUrl,
    getMapStatusUrl,
    getOrderUrl,
    getSetPaymentInstructionUrl,
    getSoldSeatInfoUrl,
    getTicketSalesUrl,
    getUnitsHoldsUrl,
};
